import { HttpTypes } from '@/types';
import { AdminBlogPostCreateResponse } from '@/types/http/blog/blog-posts';
import { AdminBlogPostUpdateResponse } from '@/types/http/blog/blog-posts';
import { AdminBlogPostDeleteResponse } from '@/types/http/blog/blog-posts';
import { BaseBlogPost } from '@/types/http/blog/blog-posts/common';
import { AxiosInstance } from 'axios';

class BlogPosts {
  private client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async list(queryParams: HttpTypes.FindParams): Promise<HttpTypes.IResponse<BaseBlogPost[]>> {
    const result = await this.client.get('/sites/blogpost', {
      params: queryParams,
    });
    return result.data;
  }

  async create(
    data: HttpTypes.AdminCreateBlogPost
  ): Promise<HttpTypes.IResponse<AdminBlogPostCreateResponse>> {
    const result = await this.client.post('/sites/blogpost', data);

    return result.data;
  }

  async detail(id: string): Promise<HttpTypes.IResponse<BaseBlogPost>> {
    const result = await this.client.get(`/sites/blogpost/${id}`);
    return result.data;
  }

  async update(
    data: HttpTypes.AdminUpdateBlogPost
  ): Promise<HttpTypes.IResponse<AdminBlogPostUpdateResponse>> {
    const result = await this.client.put(`/sites/blogpost/${data.blog_spot_id}`, data);
    return result.data;
  }

  async delete(id: string): Promise<HttpTypes.IResponse<AdminBlogPostDeleteResponse>> {
    const result = await this.client.delete(`/sites/blogpost/${id}`);
    return result.data;
  }

  async duplicate(title: string) {
    const result = await this.client.get('/sites/blogpost/check-duplicate', {
      params: {
        title,
      },
    });
    return result.data;
  }
}

export default BlogPosts;
